<template>
	<div class="client-attendance">
		<div 
			@click="$modal.show(`sa_${table.id}_${client.id}`)" 
			:class="`type_${attendance}`"
			class="client-attendance-text"
			:style="`color: ${attendances[attendance] ? attendances[attendance].color : ''}`"
			role="button"
		>
			<span>
				<b>{{ attendances[attendance] ? attendances[attendance].title : 'Не выбран'}}</b>
			</span>
			<i class="icon-content ti-angle-down"></i>
		</div>
		<set-attendance v-model="attendance" :table="table" :client="client" :modal="`sa_${table.id}_${client.id}`" />
	</div>
</template>

<script>
import SetAttendance from './SetAttendance.vue';
export default {
	created() {
		for (let i = 0; i < this.value.length; i++) {
			if (this.value[i].id == this.table.id) {
				this.attendance = this.value[i].pivot.status;
			}
		}
	},
	mounted(){
		var td = document.querySelectorAll(".table-journal .table-journal-tr .client-attendance")
		// td = Array.from(tr)
		// td.forEach((el, i)=>{
		// 	console.log(el.closest(".table-journal-tr"))
		// })
		// td.reduce((result, item)=>{
		// 		// console.log(result.querySelector())
		// 		return item
		// 	if(result){
		// 		// console.log(result.offsetWidth)
		// 	}
		// })
	},
	data() {
		return {
			attendance: null,
			attendances: [
				{
						title: 'Присутствует',
						color: '#30AB02',
				},
				{
						title: 'Опоздал',
						color: '#DECE3C',
				},
				{
						title: 'По болезни',
						color: '#3CA4DE',
				},
				{
						title: 'Неув.',
						color: '#DE3C80',
				},
				{
						title: 'По уважительной причине',
						color: 'brown',
				},
			]
		};
	},
	props: ["client", "value", "table"],

	components: { SetAttendance }
};
</script>

<style lang="scss">
$color-t-1: #8B77F1;
.client-attendance {
	position: relative;
	overflow: visible;
	min-width: 150px;
}

.client-attendance-text{
	border: 1px solid #cbcbcb;
	color: #cbcbcb;
	border-radius: 30px;
	padding: 4px 4px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	span{
		padding: 3px 10px;
		background-color: currentColor;
		border-radius: 30px;
		white-space: nowrap;
		font-size: 12px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 15px;
		b{
			font-weight: 400;
			color: white;
		}
	}
	.icon-content{
		color: #cbcbcb;
		cursor: pointer;
    display: block;
    width: 16px;
    text-align: center;
    font-size: 13px;
    margin-left: auto;
		margin-right: 5px;
	}
}

.client-attendance-icons {
	svg {
		width: 30px;
		stroke: currentColor;
		color: #a5a534;
	}
}

.attendance {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	padding: 0;
	margin: 0;
	width: 18px;
	height: 18px;
	max-width: 18px;
	max-height: 18px;
	min-width: 18px;
	min-height: 18px;
	border: 1px solid #999;
	text-align: center;
	color: #111;

	&.type_null {
		background: #fff;
		color: #fff;
	}

}
</style>

